import { render } from "./VolumeBuys.vue?vue&type=template&id=7868c075&scoped=true"
import script from "./VolumeBuys.vue?vue&type=script&lang=js"
export * from "./VolumeBuys.vue?vue&type=script&lang=js"

import "./VolumeBuys.vue?vue&type=style&index=0&id=7868c075&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7868c075"]])

export default __exports__